module.exports = __webpack_public_path__ + "img/img_list_null.24232348.svg";